import Resource from "./angular/Resource";

export default Resource;
